import React, { useEffect, useState } from "react";
import ProductCard from "../../Components/ProductCard/ProductCard";
import "./ProductsPage.scss";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { GetProducts } from "../../api/products.api";
import { setProducts } from "../../Redux/Products/Products.actions";

const ProductsPage = ({ match, history }) => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products.products);
  const [showLoading, setShowLoading] = useState(false);
  // const products = sampleProducts;

  useEffect(() => {
    const getData = async () => {
      setShowLoading(true);
      const data = await GetProducts(match.params.catagory);
      dispatch(setProducts(data));
      setShowLoading(false);
    };
    getData();
  }, []);

  return (
    <div className="ProductsPage">
      <h1>{match.params.catagory.toUpperCase()}</h1>

      {!showLoading ? (
        <div className="products">
          {products.map((product) => (
            <>
              <ProductCard key={products._id} data={product} />
            </>
          ))}
        </div>
      ) : (
        <div className="loading">
          <CircularProgress size={50} color="#43444d" />
        </div>
      )}
    </div>
  );
};

export default ProductsPage;
